import { useCallback, useContext } from "react";
import { ActiveMonthContext } from "../context/page-context";
import { monthSlugs } from "../services/centralStore";
import getDefaultMonthIndex from "../services/getDefaultMonthIndex";

export const useMonth = ({ ignoreOverview }: { ignoreOverview?: boolean }) => {
    const [month, setMonth] = useContext(ActiveMonthContext);
    let activeMonth = month;
    if (ignoreOverview && month == "climate") {
        activeMonth = monthSlugs[getDefaultMonthIndex()];
    }
    const setMonthComplete = useCallback(
        (m: string) => {
            setMonth(m);
        },
        [setMonth]
    );
    return { month: activeMonth, setMonth: setMonthComplete };
};
